import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { superstyled } from '@zenbusiness/zui/styles';

export const HomeBanners = superstyled({
  tag: Box,
  name: 'HomeBanners',
  slot: 'HomeBanners',
  styles: () => ({
    marginBlockEnd: '1.5rem',

    // An empty wrapper would still take a flex gap in Home's stack.
    '&:empty': {
      display: 'none',
    },

    '& > :first-of-type': {
      marginTop: 0,
    },
  }),
});

// Lays out like zui's own banner action, which can't send a server-provided element name.
export const ClickstreamCta = superstyled({
  tag: Button,
  name: 'HomeBanners',
  slot: 'ClickstreamCta',
  styles: ({ theme }) => ({
    flex: 1,

    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  }),
});
